import AuthlessA5PrintPage from "@/components/common-receipt/AuthlessA5PrintPage";
import { selectFirstPrintRowOrEmpty } from "@/components/common-receipt/select-print-row";
import { lagatReceiptA5Props, type LagatReceiptPrintRecord } from "./lagat-receipt-print-content";

const LagatReceiptPrint = () => (
  <AuthlessA5PrintPage<LagatReceiptPrintRecord>
    location="lagatReceipts"
    buildId={(routeId) => `print/${routeId}`}
    selectRow={selectFirstPrintRowOrEmpty}
    toProps={lagatReceiptA5Props}
  />
);

export default LagatReceiptPrint;
